// Mapeo entre las secciones del frontend y los tipos de documento del backend
// Cada sección puede tener múltiples tipos de documento asociados

export const sectionToDocumentType = {
  // 1. Información de la Entidad
  'mision-vision': 'MISION_VISION',
  'estructura-organica': 'ESTRUCTURA_ORGANICA',
  'mapas-procesos': 'MAPAS_PROCESOS',
  'directorio-institucional': 'DIRECTORIO_INSTITUCIONAL',
  'directorio-servidores': 'DIRECTORIO_SERVIDORES',
  'directorio-entidades': 'DIRECTORIO_ENTIDADES',
  'directorio-agremiaciones': 'DIRECTORIO_AGREMIACIONES',
  'procedimientos-decisiones': 'PROCEDIMIENTOS_DECISIONES',
  'mecanismo-solicitudes': 'MECANISMO_SOLICITUDES',
  'calendario-actividades': 'CALENDARIO_ACTIVIDADES',
  'decisiones-publico': 'DECISIONES_PUBLICO',
  'entes-vigilancia': 'ENTES_VIGILANCIA',
  'hojas-vida': 'HOJAS_VIDA',
  
  // 2. Normativa
  'leyes': 'LEYES',
  'decreto-unico': 'DECRETO_UNICO',
  'normativa-aplicable': 'NORMATIVA_APLICABLE',
  'diario-oficial': 'DIARIO_OFICIAL',
  'politicas-lineamientos': 'POLITICAS_LINEAMIENTOS',
  'agenda-regulatoria': 'AGENDA_REGULATORIA',
  'suin': 'SUIN',
  'sistema-busqueda': 'SISTEMA_BUSQUEDA',
  'proyectos-normativos': 'PROYECTOS_NORMATIVOS',
  'comentarios-respuesta': 'COMENTARIOS_RESPUESTA',
  'participacion-sucop': 'PARTICIPACION_SUCOP',
  
  // 3. Contratación
  'contratacion': 'PLAN_ADQUISICIONES',
  'plan-adquisiciones': 'PLAN_ADQUISICIONES',
  'info-contractual': 'INFO_CONTRACTUAL',
  'ejecucion-contratos': 'EJECUCION_CONTRATOS',
  'manual-contratacion': 'MANUAL_CONTRATACION',
  'formatos-contratos': 'FORMATOS_CONTRATOS',
  
  // 4. Planeación, Presupuesto e Informes
  'presupuesto-general': 'PRESUPUESTO_GENERAL',
  'ejecucion-presupuestal': 'EJECUCION_PRESUPUESTAL',
  'plan-accion': 'PLAN_ACCION',
  'proyectos-inversion': 'PROYECTOS_INVERSION',
  'informes-empalme': 'INFORMES_EMPALME',
  'info-publica': 'INFO_PUBLICA',
  'informes-gestion': 'INFORMES_GESTION',
  'informes-control-interno': 'INFORMES_CONTROL_INTERNO',
  'informe-defensa': 'INFORME_DEFENSA',
  'informes-acceso': 'INFORMES_ACCESO',
  
  // 5. Trámites
  'tramites-servicios': 'TRAMITES_SERVICIOS',
  
  // 6. Participa
  'participa-descripcion': 'PARTICIPA_DESCRIPCION',
  'diagnostico-necesidades': 'DIAGNOSTICO_NECESIDADES',
  'planeacion-participativa': 'PLANEACION_PARTICIPATIVA',
  'consulta-ciudadana': 'CONSULTA_CIUDADANA',
  'colaboracion-innovacion': 'COLABORACION_INNOVACION',
  'rendicion-cuentas': 'RENDICION_CUENTAS',
  'control-social': 'CONTROL_SOCIAL',
  
  // 7. Datos abiertos
  'gestion-informacion': 'GESTION_INFORMACION',
  'datos-abiertos': 'DATOS_ABIERTOS',
  
  // 8. Grupos de Interés
  'info-ninos': 'INFO_NINOS',
  'info-mujeres': 'INFO_MUJERES',
  
  // 9. Información específica
  'info-especifica': 'INFO_ESPECIFICA',
  
  // 10. Información tributaria
  'recaudo-rentas': 'RECAUDO_RENTAS',
  'tarifas-ica': 'TARIFAS_ICA'
}

// Función para obtener el código del tipo de documento desde el ID de sección
export function getDocumentTypeCode(sectionId) {
  return sectionToDocumentType[sectionId] || null
}

// Función para obtener el ID de sección desde el código del tipo de documento
export function getSectionIdFromCode(code) {
  const entry = Object.entries(sectionToDocumentType).find(([_, value]) => value === code)
  return entry ? entry[0] : null
}
